import { PriceTemplate } from "./pricing";
import { QuoteSummary } from "./quote";
import { UserType } from "../shared/enums";



export class TyreBrand {
    tyreBrandId: number;
    brandName: string;
    isImport: boolean;
    isRetread: boolean;
    isLocal: boolean;
}

export class ClientLink {
    clientId: number;
    clientName: string;
    clientTel: string;
    clientCell: string;
    connectionTypeId: number;
    latitude: number;
    longitude: number;
}

export class ServiceProviderLink extends ClientLink {
    callcentreId: number | null = null;
    callcentreName: string | null = null;
}

export class IncidentClientLink extends ClientLink {
    incidentDistance: number | null;
    incidentTravelTimeMinutes: number | null;
    technicianStatusId: number;
    stockAvailable: boolean;
    isActive: boolean;
    activeQuoteId: number;
    quoteSummary: QuoteSummary;
    hasAccurateLocation: boolean;
    incidentTravelTimeMinutesAdded: number;
    hasSpAccepted: boolean;
    canSelectBreakdownTechnician: boolean | null;
    whatsappGroupLink: string | null;
    whatsappGroupName: string | null;

    constructor(source?: ClientLink) {
        super(); // Call the parent constructor... which doesn't exist
        if (source) {
            // Copy properties from the source object
            this.clientId = source.clientId;
            this.clientName = source.clientName;
            this.connectionTypeId = source.connectionTypeId;
            this.latitude = source.latitude;
            this.longitude = source.longitude;
            
        }
    }
}

export class TyreSize {
    gencode: string;
    width: number;
    profile: number;
    rim: number;
    size: string;

}

export class Driver {
    driverId: number = 0;
    name: string = '';
    phoneNumber: string = '';
}

export class BreakdownTechnician extends Driver {
    statusId: number;
    dtLogged: Date;
    latitude: number;
    longitude: number;
    clientEts: number;
}

export class Vehicle {
    vehicleId: number = 0;
    registrationNumber: string = '';
    vinNumber: string = '';

}

export class ClientMetaFlags {
    mustUpdateLocation: boolean = false;
}

export class LookupItem {
    id: number;
    value: string;
}

export class CallcentreOperator {
    userId: number = 0;
    userEmail: string = '';
    userCell: string = '';
    username: string = '';
    firstName: string = '';
    lastName: string = '';
    clientId: number = 0;
    userType: UserType = UserType.unknown;
    isWhatsappOnlyNotificationRecipient: boolean = false;
}

export class ClientMeta {
    tyreBrands: TyreBrand[] = [];
    clientLinks: ClientLink[] = [];
    serviceProviderLinks: ServiceProviderLink[] = [];
    tyreSizes: TyreSize[] = [];
    truckDrivers: Driver[] = [];
    fleetVehicles: Vehicle[] = [];
    breakdownTechnicians: BreakdownTechnician[] = [];
    savedLocations: SavedLocation[] = [];
    priceTemplates: PriceTemplate[] = [];
    workDoneTypes: LookupItem[] = [];
    cancelReasons: LookupItem[] = [];
    callcentreOperators: CallcentreOperator[] = [];
    flags: ClientMetaFlags = new ClientMetaFlags();
}

export class SavedLocation {
    savedLocationId: number = 0;
    clientId: number = 0;
    description: string = '';
    descriptionShort: string = '';
    geocodedDescription: string = '';
    latitude: number;
    longitude: number;
}

export class PricingTemplate {
    pricingTemplateId: number = 0;
    clientId: number = 0;
    pricingName: string = '';
    description: string = '';
    pricingMethod: number = 0;
    pricingValue: number = 0;
}

export class FleetClient extends ClientLink {
    operatorName: string | null;
    operatorCell: string | null;
    pricingId: number | null;
    vehicles: Vehicle[] | null;
    drivers: Driver[] | null;
    whatsappGroupLink: string | null;
    whatsappGroupName: string | null;
}

export class Client {
    clientId: number;
    clientName: string;
    connectionTypeId: number;
    latitude: number;
    longitude: number;
    clientTel: string;
    clientCell: string | null;
    addressCity: string | null;
    dtLastModified: Date;
    pricingTemplate: PricingTemplate | null;
}

export class ServiceProviderClient extends Client {
    technicians: BreakdownTechnician[] | null;
    breakdownsAllocated: number | null;
    clientGroupId: number | undefined;
    clientGroupName: string | undefined;
    clientGroupClassificationId: number | undefined;
    clientGroupClassification: string | undefined;
    whatsappGroupLink: string | null;
    whatsappGroupName: string | null;
    dtLastStatusRequest?: Date | null;
}

export class ClientSettings {
    clientId: number;
    clientName: string;
    clientTel: string;
    addressCity: string;
    lat: number;
    lon: number;
    standardDelayTimeMins: number;
}


export class MergeFleetRequest{
    targetClient: FleetClient;
    sourceClientIds: number[];
}

export class Transporter {
    transporterId: number;
    transporterName: string;
}

export class ServiceProviderSummary{
    clientId: number;
    clientName: string;
    latitude: number;
    longitude: number;
    clientTel: string;
    addressCity: string;
    clientCell: string;
    clientGroupId: number;
    clientGroupName: string;
}

export class ServiceProviderGroupedList {
    linkedServiceProviders: ServiceProviderClient[] = [];
    otherServiceProviders: ServiceProviderSummary[] = [];
}

export class LinkServiceProviderRequest {
    pricingTemplateId: number;
    whatsappGroupLink: string;
    whatsappGroupName: string;
}
